import { randomNumber } from '../../../../utilities'
import { ExtricationConstants } from './extrication.constants'
import { IExtricationAction, IExtricationState } from './extrication.types'

export const initialExtricationState: IExtricationState = {
  assessedBy: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Extrication',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  isEkgImport: null,
  nemsisCode: null,
}

export function extricationReducer(
  state: IExtricationState = initialExtricationState,
  action: IExtricationAction
): IExtricationState {
  switch (action.type) {
    case ExtricationConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case ExtricationConstants.SET_DATE:
      return { ...state, date: action.date }
    case ExtricationConstants.SET_TIME:
      return { ...state, time: action.time }
    case ExtricationConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case ExtricationConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case ExtricationConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case ExtricationConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case ExtricationConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case ExtricationConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case ExtricationConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case ExtricationConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case ExtricationConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case ExtricationConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case ExtricationConstants.SET_STATE:
      return { ...action.extricationState, updateInputRows: true }
    case ExtricationConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case ExtricationConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case ExtricationConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case ExtricationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case ExtricationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case ExtricationConstants.RESET_STATE:
      return {
        assessedBy: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        key: randomNumber().toString(),
        date: '',
        time: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        type: 'Extrication',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        isEkgImport: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
